const defaultFunction = (value) => value;
const checkValueIsStringOrNumber = (value) => {
  if (typeof value !== 'string' && (typeof value !== 'number' || isNaN(value))) {
    throw new TypeError('value must return a string or number');
  }
}
const checkArrayCanIterable = (array) => {
  if (typeof array[Symbol.iterator] !== 'function') {
    throw new TypeError('array must be iterable');
  }
}

function isJSONSerializable(obj) {
  try {
    JSON.stringify(obj);
    return true; // 如果序列化成功，返回true
  } catch (e) {
    return false; // 如果序列化失败，返回false
  }
}

export default {
  /**
   * @description 自定义数组分组方法
   * @param {Function} keyFun - 用于生成分组键的函数
   * @param {Function} [valueFun] - 用于生成分组值的函数（可选）
   * @returns {Object} 分组后的对象
   */
  zzwGroupBy: function (keyFun, valueFun = defaultFunction) {
    if (!keyFun) {
      throw new Error('keyFun is required');
    }
    const array = this;
    //判断数组是否可以迭代
    checkArrayCanIterable(array);
    return array.reduce((acc, cur) => {
      let key = keyFun(cur);
      //判断key是否为字符串或者数字不能为其他类型
      let groupValue = valueFun(cur);
      if (!acc[key]) {
        acc[key] = [groupValue];
      } else {
        acc[key].push(groupValue);
      }
      return acc;
    }, {});
  },
  /**
   * @description 将数组转换为对象
   * @param {Function} keyFun - 用于生成分组键的函数
   * @param {Function} [valueFun] - 用于生成值的函数（可选）
   * @returns {Object} 转换后的对象
   */
  zzwListToObject: function (keyFun, valueFun = defaultFunction) {
    if (!keyFun) {
      throw new Error('keyFun is required');
    }
    const array = this;
    //判断数组是否可以迭代
    checkArrayCanIterable(array);
    return array.reduce((acc, cur) => {
      let key = keyFun(cur);
      //判断key是否为字符串或者数字不能为其他类型
      acc[key] = valueFun(cur);
      return acc;
    }, {});
  },
  /**
   * @description 自定义控制处理数量队列
   * @param {Number} maxProcessCount - 最大的同时处理数量
   * @param {Function} processFunction - 每个处理函数 会将每个元素作为参数传递进去，返回Promise
   * @param {Function} [completeEveryFunction] - 每个处理函数完成之后,会传入当的 完成的数量 总数 当前元素 当前索引
   * @returns {Promise} - 返回Promise 完成之后会传入所有的结果数组 和传入时的顺序一致
   */
  zzwProcessQueue: function (maxProcessCount, processFunction, completeEveryFunction) {
    const data = this;
    //判断数组是否可以迭代
    checkArrayCanIterable(data);
    if (!processFunction) {
      processFunction = (item) => {
        return Promise.resolve(item);
      }
    }
    return new Promise((resolve, reject) => {
      if (maxProcessCount === null || maxProcessCount === undefined || isNaN(maxProcessCount) || typeof maxProcessCount !== 'number' || maxProcessCount <= 0) {
        throw new TypeError('maxProcessCount must be a number and greater than 0');
      }
      if (typeof processFunction !== 'function') {
        throw new TypeError('processFunction must be a function');
      }
      if (completeEveryFunction && typeof completeEveryFunction !== 'function') {
        throw new TypeError('completeEveryFunction must be a function');
      }
      const total = data.length;
      if (total === 0) {
        resolve([]);
        return;
      }
      let currentProcessCount = 0;
      let completedCount = 0;
      let hasError = false;
      let result = [];
      let index = 0;
      const _process = () => {
        if (data.length === 0 || currentProcessCount >= maxProcessCount || hasError) {
          return;
        }
        const item = data.shift();
        currentProcessCount++;
        const currentIndex = index++;
        processFunction(item).then((data) => {
          currentProcessCount--;
          completedCount++;
          result[currentIndex] = data;
          if (completeEveryFunction) {
            completeEveryFunction(completedCount, total, item, currentIndex);
          }
          if (completedCount === total) {
            resolve(result);
          } else {
            if (!hasError) {
              _process();
            }
          }
        }).catch(err => {
          hasError = true;
          reject(err);
        });
        _process();
      }
      _process();
    });
  },
  /**
   * @description 数组求和
   * @param {Function} [valueFun] - 用于计算和的函数（可选）
   * @param {Function} [filterFun] - 用于过滤的函数（可选）只能返回 true 或者 false
   * @returns {Number} - 返回和
   */
  zzwSum: function (valueFun = defaultFunction, filterFun = () => true) {
    const array = this;
    //判断数组是否可以迭代
    checkArrayCanIterable(array);
    return array.reduce((acc, cur) => {
      let value = valueFun(cur);
      const filterResult = filterFun(cur);
      if (filterResult === true) {
        checkValueIsStringOrNumber(value);
        acc = acc.zzwAdd(Number(value))
      }
      return acc;
    }, 0);
  },
  /**
   * @description json数组克隆
   */
  zzwClone() {
    const obj = this;
    if (!isJSONSerializable(obj)) {
      return obj;
    }
    return JSON.parse(JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/utils/extensions/Array.js